const completeTourAPI = (name) => `api/tours/complete?name=${name}`;
const getTourCompletionStatusAPI = (name) => `api/tours/status?name=${name}`;

export const tourEndpoints = {
  getTourCompletionStatusAPI,
  completeTourAPI,
};
